document.addEventListener('DOMContentLoaded', () => {
  const navItems = document.querySelectorAll('.header__nav-item');
  let timeout;
  const HOVER_DELAY = 300; // milliseconds before hiding menu
  let activeMenu = null;

  // Function to hide all mega menus
  const hideAllMegaMenus = (exceptMenu = null) => {
    navItems.forEach(item => {
      const menu = item.querySelector('.desktop__mega-menu');
      if (menu && menu !== exceptMenu) {
        menu.style.visibility = 'hidden';
        menu.style.opacity = '0';
        menu.style.pointerEvents = 'none';
      }
    });
  };

  // Function to show a specific mega menu
  const showMegaMenu = (menu) => {
    clearTimeout(timeout);
    hideAllMegaMenus(menu);
    
    menu.style.visibility = 'visible';
    menu.style.opacity = '1';
    menu.style.pointerEvents = 'auto';
    menu.style.display = 'flex';
    activeMenu = menu;
  };

  navItems.forEach(navItem => {
    const megaMenu = navItem.querySelector('.desktop__mega-menu');
    if (!megaMenu) return;

    // Show menu immediately on hover
    navItem.addEventListener('mouseenter', () => {
      showMegaMenu(megaMenu);
    });

    // Delay hiding the menu when mouse leaves
    navItem.addEventListener('mouseleave', (e) => {
      // Check if moving toward the mega menu
      const megaMenuRect = megaMenu.getBoundingClientRect();
      const isMovingTowardMenu = 
        e.clientY >= navItem.getBoundingClientRect().bottom && 
        e.clientX >= megaMenuRect.left && 
        e.clientX <= megaMenuRect.right;

      // Check if moving to another nav item
      let isMovingToAnotherNavItem = false;
      navItems.forEach(item => {
        if (item !== navItem) {
          const itemRect = item.getBoundingClientRect();
          if (e.clientX >= itemRect.left && 
              e.clientX <= itemRect.right && 
              e.clientY >= itemRect.top && 
              e.clientY <= itemRect.bottom) {
            isMovingToAnotherNavItem = true;
          }
        }
      });

      // Don't hide if moving to another nav item or to the mega menu
      if (isMovingToAnotherNavItem || isMovingTowardMenu) return;

      timeout = setTimeout(() => {
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.opacity = '0';
        megaMenu.style.pointerEvents = 'none';
        activeMenu = null;
      }, HOVER_DELAY);
    });

    // Keep menu visible when hovering mega menu
    megaMenu.addEventListener('mouseenter', () => {
      showMegaMenu(megaMenu);
    });

    // Delay hiding when leaving mega menu
    megaMenu.addEventListener('mouseleave', (e) => {
      // Check if moving to another nav item
      let isMovingToNavItem = false;
      navItems.forEach(item => {
        const itemRect = item.getBoundingClientRect();
        if (e.clientX >= itemRect.left && 
            e.clientX <= itemRect.right && 
            e.clientY >= itemRect.top && 
            e.clientY <= itemRect.bottom) {
          isMovingToNavItem = true;
        }
      });

      if (isMovingToNavItem) return;

      timeout = setTimeout(() => {
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.opacity = '0';
        megaMenu.style.pointerEvents = 'none';
        activeMenu = null;
      }, HOVER_DELAY);
    });
  });

  // Hide all menus when clicking outside
  document.addEventListener('click', (e) => {
    let isClickInsideMenu = false;
    navItems.forEach(item => {
      if (item.contains(e.target)) {
        isClickInsideMenu = true;
      }
    });

    if (!isClickInsideMenu && activeMenu) {
      activeMenu.style.visibility = 'hidden';
      activeMenu.style.opacity = '0';
      activeMenu.style.pointerEvents = 'none';
      activeMenu = null;
    }
  });
}); 